// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersBar_wrap__qZ44D {
  display: flex;
  align-items: stretch;
  gap: var(--space-2);
  flex-wrap: wrap;
  margin: var(--space-4) 0;
  padding: var(--space-3);
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  box-shadow: none;
}

/* Base field styles shared by selects & inputs */
.FiltersBar_field__0Hs5p {
  flex: 1 1 160px;                /* grows but won’t get too tiny */
  min-width: 140px;               /* safety floor for mid-widths */
  min-height: 36px;
  padding: 7px 10px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font: inherit;
  font-size: 0.875rem;
  line-height: 1.3;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.FiltersBar_field__0Hs5p:hover {
  border-color: var(--text-secondary);
}

.FiltersBar_field__0Hs5p:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

/* Selects: remove native arrow, add a lightweight chevron */
.FiltersBar_select__-EaMZ {
  appearance: none;
  background-image:
    linear-gradient(45deg, transparent 50%, currentColor 50%),
    linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position:
    calc(100% - 16px) calc(50% - 2px),
    calc(100% - 11px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding-right: 30px; /* room for arrow */
  color: var(--text-primary);
}

/* Date inputs: consistent look */
.FiltersBar_date__up\\+4B {
  color: var(--text-primary);
}

/* Compact spacing on small screens; fields full-width nicely */
@media (max-width: 680px) {
  .FiltersBar_wrap__qZ44D {
    gap: 8px;
    padding: 12px;
  }

  /* Two filters per row instead of one tall column. */
  .FiltersBar_field__0Hs5p {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    min-width: 0;
    padding: 8px 10px;
    font-size: 0.8125rem;
  }

  .FiltersBar_select__-EaMZ {
    padding-right: 30px;
  }
}

/* Very small phones: slightly larger tap targets */
@media (max-width: 420px) {
  .FiltersBar_wrap__qZ44D {
    margin: var(--space-3) 0;
    padding: var(--space-2);
  }

  .FiltersBar_field__0Hs5p {
    min-height: 40px;
    padding: 8px 10px;
  }
}

/* Respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .FiltersBar_field__0Hs5p { transition: none !important; }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashBoard/FiltersBar.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,eAAe,iBAAiB,iCAAiC;EACjE,gBAAgB,gBAAgB,gCAAgC;EAChE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB;;mDAEiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB;;8DAE4D;EAC5D;;qCAEmC;EACnC,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB,EAAE,mBAAmB;EACxC,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE;IACE,QAAQ;IACR,aAAa;EACf;;EAEA,oDAAoD;EACpD;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE,2BAAS,2BAA2B,EAAE;AACxC","sourcesContent":["@import url('../../colors.css');\n\n.wrap {\n  display: flex;\n  align-items: stretch;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n  margin: var(--space-4) 0;\n  padding: var(--space-3);\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  box-shadow: none;\n}\n\n/* Base field styles shared by selects & inputs */\n.field {\n  flex: 1 1 160px;                /* grows but won’t get too tiny */\n  min-width: 140px;               /* safety floor for mid-widths */\n  min-height: 36px;\n  padding: 7px 10px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-input);\n  background: var(--bg);\n  color: var(--text-primary);\n  font: inherit;\n  font-size: 0.875rem;\n  line-height: 1.3;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.field:hover {\n  border-color: var(--text-secondary);\n}\n\n.field:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n/* Selects: remove native arrow, add a lightweight chevron */\n.select {\n  appearance: none;\n  background-image:\n    linear-gradient(45deg, transparent 50%, currentColor 50%),\n    linear-gradient(135deg, currentColor 50%, transparent 50%);\n  background-position:\n    calc(100% - 16px) calc(50% - 2px),\n    calc(100% - 11px) calc(50% - 2px);\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n  padding-right: 30px; /* room for arrow */\n  color: var(--text-primary);\n}\n\n/* Date inputs: consistent look */\n.date {\n  color: var(--text-primary);\n}\n\n/* Compact spacing on small screens; fields full-width nicely */\n@media (max-width: 680px) {\n  .wrap {\n    gap: 8px;\n    padding: 12px;\n  }\n\n  /* Two filters per row instead of one tall column. */\n  .field {\n    flex: 1 1 calc(50% - 4px);\n    min-width: 0;\n    padding: 8px 10px;\n    font-size: 0.8125rem;\n  }\n\n  .select {\n    padding-right: 30px;\n  }\n}\n\n/* Very small phones: slightly larger tap targets */\n@media (max-width: 420px) {\n  .wrap {\n    margin: var(--space-3) 0;\n    padding: var(--space-2);\n  }\n\n  .field {\n    min-height: 40px;\n    padding: 8px 10px;\n  }\n}\n\n/* Respect reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .field { transition: none !important; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `FiltersBar_wrap__qZ44D`,
	"field": `FiltersBar_field__0Hs5p`,
	"select": `FiltersBar_select__-EaMZ`,
	"date": `FiltersBar_date__up+4B`
};
export default ___CSS_LOADER_EXPORT___;
